import * as yup from 'yup';

import { EmptyProjectRequest } from './empty-project-request';

export const createProjectFormValidationSchema: yup.SchemaOf<EmptyProjectRequest> = yup.object().shape({
	name: yup.string().required('Enter project name').min(2).max(50)
});
